import { Tag } from "antd";
import React, { Component, CSSProperties } from "react";
import { SelectOptionsInterface } from "../helpers/shared-interfaces";

interface Props {
  style?: CSSProperties;
  compact?: boolean;
  tagStyle?: CSSProperties;
  color?: string;
  tags: SelectOptionsInterface[];
}

const tagColors: Record<string, string> = {
  Active: "green",
  Inactive: "volcano",
  Closed: "red",
  "Non-Paying": "orange",
  Deceased: "black",
  "No Comm.": "purple",
  Suspended: "magenta",
  Retired: "gold",
  "Retired with Redeemable Balance": "cyan",
  "Retired without Redeemable Balance": "geekblue",
  "Awaiting First Payment": "blue",
  Kindergarten: "lime",
  Dormant: "gray",
  "Ported Out": "brown"
};

class TagsSection extends Component<Props> {
  render(): JSX.Element {
    const { tags, style, compact, tagStyle, color: colorOverride } = this.props;
    const containerStyle: CSSProperties = compact
      ? {
          border: "none",
          padding: 0,
          borderRadius: 0,
          backgroundColor: "transparent",
        }
      : {
          border: "1px solid rgb(232 232 232)",
          padding: "16px 20px",
          borderRadius: "8px",
          backgroundColor: "#fafafa",
        };
    const resolvedTagStyle: CSSProperties = compact
      ? { fontSize: "11px", padding: "1px 6px", lineHeight: "16px" }
      : { fontSize: "12px", padding: "4px 10px" };

    return (
      <div
        style={{
          boxSizing: "border-box",
          ...containerStyle,
          ...style,
        }}
      >
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
          {tags.map((tag: SelectOptionsInterface) => {
            const color = colorOverride || tagColors[tag.name] || "default";

            return (
              <Tag
                key={tag.id}
                color={color}
                style={{ ...resolvedTagStyle, ...tagStyle }}
              >
                {tag.name}
              </Tag>
            );
          })}
        </div>
      </div>
    );
  }
}

export default TagsSection;
